<template>
    <div class="container">
        <!-- <div class="container-verify">
            <div v-if="status.length === 0" class="verify-tips tips-title">Verifying Your Email</div>
            <div v-if="status === 'success'" class="verify-tips tips-title">Success</div>
            <div v-if="status === 'failed'" class="verify-tips tips-title">Failed</div>
            <div class="verify-tips verify-status">
                <div  v-if="status === 'failed'" class="verify-tips verify-message">{{tips}}</div>
                <div  v-if="status === 'success'" class="verify-tips verify-message">Thank You For Verify Your Email</div>
                <spin v-if="status.length === 0" fix>
                    <Icon type="ios-loading" size=60 class="demo-spin-icon-load"></Icon>
                </spin>
            </div>
        </div> -->
        <div v-if="status.length === 0">
            <div class="statusImage">
                <spin fix>
                    <Icon type="ios-loading" size=60 class="demo-spin-icon-load"></Icon>
                </spin>
            </div>
        </div>
        <div v-if="status === 'success'">
            <div class="statusImage">
                <img src="../assets/success.png" />
            </div>
            <p class="statusTitle">Your email address is verified.</p>
            <div class="statusTips">Congratulations! You are now ready to enjoy all digital experiences in CT Corp ecosystem.</div>
            <!-- <div class="open-allo-bank">
                <button @click="openAlloBank">Open Allo Bank</button>
            </div> -->
        </div>
        <div v-if="status === 'failed'">
            <div class="statusImage">
                <img src="../assets/failed.png" />
            </div>
            <p class="statusTitle">We couldn't verify your email address</p>
            <div class="statusTips">Sorry, we had trouble verifying your email address. Please try again .</div>
        </div>
    </div>
</template>
<script>
import {emailAuthentication} from '../api/server'



export default {
    data () {
        return {
            tips:'error',
            status: ''
        }
    },
    methods: {
        // openAlloBank() {
        //     window.location.href = 'allonative://allo.com?';
        // },
        async emailAuthentication () {
            const payload = {
                token: this.getParam('token')
            }
            const {data} = await emailAuthentication(payload)
            console.log(data)
            if (data.code === '00') {
                this.status = 'success'
            } else {
                this.status = 'failed'
                this.tips = data.message
            }
        },
        getParam(name) {
            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            let r = window.location.hash.substr(17).match(reg) || '';
            return r[2];
        }
    },
    mounted () {

        setTimeout(()=>{
            console.log(this.getParam('token'))
        },500)
        this.emailAuthentication()
    }
}
</script>
<style lang="scss">
.open-allo-bank {
    text-align: center;
    margin-top: 20px;
    button {
        border: none;
        background-color: #f3aa24;
        border-radius: 20px;
        width: 161px;
        height: 30px;
        color: white;
    }
}
.verify-status {
    position: relative;
    height: 150px;
    padding-top: 50px
}
.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
.container {
    // background: rgb(224, 223, 223);
    width: 100%;
    height: calc(100vh);
    padding-top: 100px
}
.statusImage {
    margin: 0 auto;
    text-align: center;
    margin-bottom: 50px
}
.statusTitle {
    text-align: center;
    font-size: 17px;
    font-weight: 600;
    margin-bottom: 20px;
    padding: 0 20px
}
.statusTips {
    text-align: center;
    font-size: 14px;
    padding: 0 20px

}
.verify-message {
    font-size: 20px;
}
.container-verify {
    width: 50%;
    height: 200px;
    margin: 0 auto;
    background: #FFF;
    border: 2px solid rgb(177, 175, 175);
    position: relative;
}
.verify-tips{
    text-align: center
}
.tips-title {
    height: 45px;
    // color: rgb(27, 26, 26);
    line-height: 45px;
    color: white;
    background: rgb(55, 127, 235);
    font-size: 22px
}
</style>


